import { apiResolver, useApi } from "@/api/useApi";
import { TenantStatisticsApiResponse } from "./Tenant.model";

export function useTenantApi() {
    const { api } = useApi();

    return {
        getTenantsStatistics: async () =>
            apiResolver<TenantStatisticsApiResponse[]>(
                api.get("/platform/admin-dashboard/statistics")
            ),
    };
}